export default "__VITE_ASSET__CgY5q50H__"